import React from 'react';
import { GoogleMap, withScriptjs, withGoogleMap } from 'react-google-maps';

const Ubicacion = (props) => {
    return(
        <GoogleMap 
        defaultZoom={17}
        defaultCenter={{ lat:  19.868389, lng: -96.776426}}
        />
    );
}

export default withScriptjs(
    withGoogleMap(
        Ubicacion
    )
)



// WEBPACK FOOTER //
// ./src/components/ubicacion.js